import {ACTION} from './constants';

let initialState={
    cards:[],
    meta: {},
    title:'',
    apiLoaded: false
};
export default function favoritesReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_FAVORTIES_CONTENT :
            return {...state, cards: [...state.cards, ...action.data.cards], meta: action.data.meta, title: action.data.title, apiLoaded: true};

        case ACTION.CLEAR_FAVORTIES_CONTENT :
            return initialState;

        default:
            return state;
    }
}